export default __webpack_public_path__ + "static/media/snow-B2.d638c48e.png";